import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/style.css";
import ProjectsVersion4 from "./ProjectsVersion4";

const Navbar = () => (
  <nav className="navbar custom-navbar">
    <div className="navbar-inner">
      <div></div> {/* Left empty tile */}
      <div className="navbar-center-links d-flex justify-content-center">
        <Link className="nav-link mx-3 nav-center-link" to="/cv">CV</Link>
        <Link className="nav-link mx-3 nav-center-link" to="/projects">Projects</Link>
        {/* <Link className="nav-link mx-3 nav-center-link" to="/loops">VibeCode</Link>
        <Link className="nav-link mx-3 nav-center-link" to="/music">Music</Link> */}
      </div>
      <div></div> {/* Right empty tile */}
    </div>
  </nav>
);

const About = () => (
  <div className="container-fluid center-content">
    <h1> About Me</h1>
    <p>I am Simon Liljedahl, a game programmer graduate from Future Games, actively seeking job opportunities to further my career.</p>
    <p>With a background in programming for both Unreal Engine and Unity, I have actively contributed to various game projects.</p>
    <p>Email: <a href="mailto:simon.liljedahl@protonmail.com">simon.liljedahl@protonmail.com</a></p>
  </div>
);

/*
// Music component - for showcasing your music work
const Music = () => (
  <div className="content" style={{ minHeight: "100vh", padding: "40px 20px" }}>
    <div className="container">
      <section className="music-description" style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1 style={{ color: "#fff", marginBottom: "20px" }}>My Music</h1>
        <p style={{ color: "#b2b2b2", fontSize: "1.1em" }}>
          Welcome to my music section. Here you can listen to my latest tracks,<br />
          beats, and musical experiments. Music production is one of my passions<br />
          alongside programming.
        </p>
      </section>
      
      <div style={{ 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        gap: "30px",
        maxWidth: "800px",
        margin: "0 auto"
      }}>
        <div style={{
          background: "#23272e",
          padding: "30px",
          borderRadius: "12px",
          width: "100%",
          textAlign: "center"
        }}>
          <h3 style={{ color: "#fff", marginBottom: "15px" }}>Latest Track</h3>
          <p style={{ color: "#b2b2b2", marginBottom: "20px" }}>Coming soon...</p>
        </div>
        
        <div style={{
          background: "#23272e",
          padding: "30px",
          borderRadius: "12px",
          width: "100%",
          textAlign: "center"
        }}>
          <h3 style={{ color: "#fff", marginBottom: "15px" }}>Beat Collection</h3>
          <p style={{ color: "#b2b2b2", marginBottom: "20px" }}>My instrumental beats and loops</p>
        </div>
      </div>
    </div>
  </div>
);
*/

// VibeCode component - similar structure to Projects
/*
const VibeCode = () => {
  const [selectedProjectIndex, setSelectedProjectIndex] = useState(null);

  // Sample VibeCode project data
  const vibeCodeProjects = [
    {
      title: "My Music Production Project",
      image: "/music-project-thumb.png", // Add your image to public folder
      description: "Music production, beats, loops, creative coding",
      introText: [
        "This is my exploration into music production and creative coding.",
        "I've been experimenting with different sounds and loops.",
        "Combining my programming skills with musical creativity.",
        "This project showcases my passion for both code and music."
      ],
      presentations: [
        {
          videoSrc: "/music-demo-video.mp4", // Add your video to public folder
          label: "Beat Creation Process",
          codeFiles: [
            {
              language: "javascript",
              localFileSrc: "/audio-processing.txt", // Add your code file to public folder
              label: "Audio Processing Code"
            }
          ]
        }
      ]
    }
  ];

  // Reuse the same ProjectPresentation component structure
  const ProjectPresentation = ({ project, onBack }) => {
    return (
      <div className="project-details-wrapper" style={{
        maxWidth: "1600px",
        margin: "0 auto",
        background: "#302c3a",
        minHeight: "100vh",
        boxSizing: "border-box"
      }}>
        <div className="video-card" style={{
          background: "#23272e",
          borderRadius: "14px",
          boxShadow: "0 2px 24px #0008",
          width: "100%",
          maxWidth: "100%",
          margin: "0 auto",
          padding: 0,
          position: "relative"
        }}>
          <button
            onClick={onBack}
            style={{
              margin: "24px 0 0 24px",
              padding: "8px 18px",
              borderRadius: "8px",
              background: "#272822",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              fontSize: "1.05em",
              fontWeight: "bold",
              boxShadow: "0 1px 4px #0002",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 2
            }}
          >
            &larr; Back to VibeCode
          </button>

          {(project.introText || project.introImage) && (
            <div className="projectstext" style={{ padding: "72px 24px 0 24px", textAlign: "center" }}>
              {project.introImage && (
                <img
                  src={project.introImage}
                  alt={project.title + " header"}
                  style={{ maxWidth: 280, borderRadius: 10, marginBottom: 12 }}
                />
              )}
              {project.introText && (
                <div className="projectstext" style={{ color: "white", marginBottom: 12, textAlign: "center" }}>
                  {Array.isArray(project.introText)
                    ? project.introText.map((para, idx) => (
                        <p key={idx}>{para}</p>
                      ))
                    : <div>{project.introText}</div>
                  }
                </div>
              )}
            </div>
          )}

          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", background: "#23272e" }}>
            {project.presentations[0]?.videoSrc && (
              <video
                width="640"
                height="360"
                src={project.presentations[0].videoSrc}
                controls
                style={{ borderRadius: "10px", margin: "24px 0 0 0", boxShadow: "0 2px 8px #0005" }}
              />
            )}
          </div>

          <div style={{ padding: "24px", textAlign: "center", color: "#b2b2b2" }}>
            <h3 style={{ color: "#fff", marginBottom: "16px" }}>{project.title}</h3>
            <p>{project.description}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {selectedProjectIndex !== null ? (
        <div className="project-details-wrapper">
          <ProjectPresentation
            project={vibeCodeProjects[selectedProjectIndex]}
            onBack={() => setSelectedProjectIndex(null)}
          />
        </div>
      ) : (
        <div className="content" style={{ minHeight: "200vh" }}>
          <div className="container, h2">
            <section className="projects-description">
              <p>
                <br />
                <br />
                Welcome to VibeCode - where programming meets music production.
                <br />
                Here I showcase my creative coding projects and music experiments.
                <br />
                Combining technical skills with artistic expression.
                <br />
                <br />
              </p>
            </section>
          </div>
          <div
            className="projects-menu"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "32px",
              justifyContent: "center",
              padding: "32px 0",
              maxWidth: "1100px",
              margin: "0 auto"
            }}
          >
            {vibeCodeProjects.map((proj, idx) => (
              <div
                key={idx}
                className="project-thumb-card"
                style={{
                  width: 320,
                  padding: 0,
                  textAlign: "center",
                  cursor: "pointer",
                  background: "none",
                  border: "none",
                  boxShadow: "none",
                  borderRadius: 0,
                  transition: "transform 0.15s"
                }}
                onClick={() => setSelectedProjectIndex(idx)}
              >
                <div style={{ fontWeight: "bold", color: "#fff", fontSize: "1.22em", marginBottom: 12 }}>{proj.title}</div>
                <img
                  src={proj.image}
                  alt={proj.title + " thumbnail"}
                  style={{
                    width: "100%",
                    height: 190,
                    objectFit: "contain",
                    background: "#2d3142",
                    marginBottom: 14
                  }}
                />
                <div style={{ color: "#b2b2b2", fontSize: "1em", minHeight: 54 }}>{proj.description}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
*/

const CurriculumVitae = () => {
  const [showLetter, setShowLetter] = useState(false);
  return (
    <>
      <div className="container-fluid">
        <div className="container mt-5">
          {/* Replace Bootstrap row/col with CSS Grid */}
          <div style={{
            display: "grid",
            background: "#2d3142",
            borderRadius: "12px",
            gridTemplateColumns: "3fr 1fr",
            gap: "2rem",
            alignItems: "start",
            width: "100%",
            padding: "2rem"
          }}>
            {/* Left section: Education and Work Experience */}
            <div style={{ 
              width: "100%",
              textAlign: "left"
            }}>
              <h4 style={{ color: "#fff", marginBottom: "50px", fontSize: "2em", fontWeight: "bold" }}>Education</h4>

              <div style={{ marginBottom: "50px" }}>
                <p style={{ color: "#e5ebf1", marginBottom: "10px", fontSize: "1.1em", fontWeight: "bold" }}>Umeå University, Jan 2024-May 2024</p>
                <p style={{ color: "#e5ebf1", marginBottom: "0", fontSize: "1.1em" }}>Course, Music production 1 (30hp)</p>
              </div>
              
              <div style={{ marginBottom: "50px" }}>
                <p style={{ color: "#e5ebf1", marginBottom: "10px", fontSize: "1.1em", fontWeight: "bold" }}>Futuregames, Skellefteå, 2021–2023</p>
                <p style={{ color: "#e5ebf1", marginBottom: "0", fontSize: "1.1em" }}>
                  A higher vocational education providing experience within
                  game programming and collaboration at game projects
                </p>
              </div>
              
              <div style={{ marginBottom: "64px" }}>
                <p style={{ color: "#e5ebf1", marginBottom: "10px", fontSize: "1.1em", fontWeight: "bold" }}>Jämtlands Gymnasium Wargentin, 2015–2018</p>
                <p style={{ color: "#e5ebf1", marginBottom: "0", fontSize: "1.1em" }}>
                  High school education aligned with Computers and ICT that
                  provided basic knowledge within: computer and network
                  technology, web-development and programming
                </p>
              </div>
              
              <h4 style={{ color: "#fff", marginBottom: "32px", fontSize: "2em", fontWeight: "bold" }}>Work Experience</h4>
              
              <div style={{ marginBottom: "32px" }}>
                <p style={{ color: "#e5ebf1", marginBottom: "10px", fontSize: "1.1em", fontWeight: "bold" }}>Bambino Games (Internship), 2023 July – Dec</p>
                <p style={{ color: "#e5ebf1", marginBottom: "0", fontSize: "1.1em" }}>
                  Development in Unity with a focus on their main application
                  and remake of one of their old mobile games from scratch
                </p>
              </div>
            </div>

            {/* Right section: Simple flexbox with mathematical positioning */}
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              gap: "20px",
              
            }}>
              {/* Profile Image */}
              <img

                src="profile.jpg"
                alt="Profile"
                style={{ 
                  width: '175px', 
                  height: '175px', 
                  objectFit: 'cover',
                  borderRadius: '8px',
                  marginRight: "0px" // Align to the left side
                }}
              />    
              
              {/* Cover Letter Button */}
              <button
                onClick={() => setShowLetter(true)}
                style={{
                  padding: "12px 24px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "1em",
                  fontWeight: "bold",
                  width: "fit-content"
                }}
              >
                View Cover Letter
              </button>

              {/* Skills Section - mathematical centering */}
              <div style={{
                display: "flex",
                width: "200px", // Exact image width
                gap: "15px",
                marginLeft: "25px", // Align to the right side
              }}>
                {/* Left skills column - 92.5px */}
                <div style={{ width: "92.5px" }}>
                  <div style={{ marginBottom: "16px" }}>
                    <p style={{ fontWeight: "bold", color: "#fff", margin: "0 0 8px 0" }}>Engine</p>
                    <div style={{ color: "#b2b2b2" }}>
                      Unity<br />
                      Unreal<br />
                      C#, C++
                    </div>
                  </div>
                  <div>
                    <p style={{ fontWeight: "bold", color: "#fff", margin: "0 0 8px 0" }}>Organize</p>
                    <div style={{ color: "#b2b2b2" }}>
                      Scrum<br />
                      Jira<br />
                      Miro
                    </div>
                  </div>
                </div>
                
                {/* Right skills column - 92.5px */}
                <div style={{ width: "92.5px" }}>
                  <div style={{ marginBottom: "16px" }}>
                    <p style={{ fontWeight: "bold", color: "#fff", margin: "0 0 8px 0" }}>Libraries</p>
                    <div style={{ color: "#b2b2b2" }}>
                      Unity DOTS<br />
                      ML-Agents<br />
                      Alteruna
                    </div>
                  </div>
                  <div>
                    <p style={{ fontWeight: "bold", color: "#fff", margin: "0 0 8px 0" }}>Other</p>
                    <div style={{ color: "#b2b2b2" }}>
                      FL Studio<br />
                      file systems<br />
                      Windows OS
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Letter Modal */}
      {showLetter && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
          }}
          onClick={() => setShowLetter(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "32px",
              maxWidth: "900px",
              maxHeight: "90vh",
              width: "90%",
              overflow: "auto",
              position: "relative",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowLetter(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "transparent",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#666",
                fontWeight: "bold",
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              ×
            </button>

            <div style={{ paddingRight: "24px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                <h2 style={{ color: "#333", margin: 0 }}>Cover Letter</h2>
              </div>

              {/* Cover letter text content */}
              <div style={{ lineHeight: "1.6", color: "#222", fontFamily: "libmono, serif" }}>
                <p>Hi I am Simon</p>

                <p>Since graduating from Futuregames, I&rsquo;ve continued to deepen myself within game development in various ways. I&rsquo;ve kept on working on a Unity-Project that began during my internship, while also doing music production and pondering on my own game ideas.</p>

                <p>Lately, I have been following along what&rsquo;s being talked about in the game industry and what&rsquo;s discussed within the programming community, and it has given me reassurance as for where to focus, refine and improve my programming.</p>

                <p>My main Game Engine is Unity and I&rsquo;m quite familiar navigating through it and making C# scripts. I also have some perspective on performance within Unity from use of Unity&rsquo;s Data-Oriented Technology Stack (DOTS) and analysing memory usage with profiler.</p>

                <p> Unreal Engine</p>

                <p>In Unreal i&rsquo;ve done stuff like prototyping, implementing gameplay mechanics, and creating shaders using the material editor. I&rsquo;d say I have basic knowledge of the engine. </p>

                <p>During my internship at Bambino games, an edutainment company, I was assigned to work on their main application.</p>

                <p>In the beginning it was hard to understand the system it was built upon, but by using a debugger, setting breakpoints and stepping through the code, I could follow along and learn how the system was behaving. </p>
                <p>That was a valuable lesson!</p>

                <p>After I had fiddled around a bit and gotten some insight, I was able to start developing further upon that system.</p>

                <p>You can view the second part of my LIA(Internship) in the projects section, where I created a mobile game in Unity</p>

                <p> Apart from my hands on experience with game programming ive gained a lot of Windows OS and filesystem experience from regular troubleshooting by the computer and productive tasks </p>

                <p>During the game projects at Futuregames we used the agile workflow for practise, specifically the Scrum framework. We used Jira for organizing tasks, Miro for brainstorming and Git or Perforce for version control.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const App = () => (
  <Router>
    <div className="page-layout">
      <div></div> {/* Left empty */}
      <div className="page-center">
        <Navbar />
        <Routes>
          <Route path="/" element={<ProjectsVersion4 />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<ProjectsVersion4 />} />
          <Route path="/cv" element={<CurriculumVitae />} />
          {/* <Route path="/loops" element={<VibeCode />} />
          <Route path="/music" element={<Music />} /> */}
        </Routes>
      </div>
      <div></div> {/* Right empty */}
    </div>
  </Router>
);

export default App;